import { useLang } from '../lib/useLang'

export default function CrmCard({ provider, connection, onConnect, onDisconnect }) {
  const { t } = useLang()
  const connected = !!connection

  return (
    <div className="rounded-xl border border-ink/10 bg-ink/[0.03] p-5 transition-colors hover:bg-ink/[0.05]">
      <div className="flex items-center gap-3">
        <img src={provider.logo} alt={provider.name} className="w-10 h-10 object-contain" />
        <h2 className="text-lg font-semibold text-ink">{provider.name}</h2>
      </div>
      {connected ? (
        <div className="mt-4">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent/15 px-2.5 py-1 text-xs font-medium text-accent">
            <span className="h-1.5 w-1.5 rounded-full bg-accent/15" />
            {t('crmCard.connected')}
          </span>
          <p className="text-sm text-ink mt-2">
            {t('crmCard.since')} {new Date(connection.created_at).toLocaleDateString()}
          </p>
          <button
            className="mt-3 rounded-lg border border-red-500/30 px-3 py-1.5 text-xs font-medium text-red-600 transition-colors hover:bg-red-500/10"
            onClick={onDisconnect}
          >
            {t('crmCard.disconnect')}
          </button>
        </div>
      ) : (
        <button
          className="mt-4 rounded-lg bg-accent/15 px-4 py-1.5 text-sm font-medium text-ink transition-colors hover:bg-accent/15"
          onClick={onConnect}
        >
          {t('crmCard.connect')}
        </button>
      )}
    </div>
  )
}
